// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2ttgA","footer":"ChangeClinic_footer__2vDjv"};